import Request from "../../../../../helpers/Request";
import LanguageHelper from "../../../../../helpers/LanguageHelper";

export default function FetchData(
  query,
  setSnackbar,
  setSnackbarMessage,
  setSeverity,
  setNumOfEntries,
) {
  const language = LanguageHelper.getLanguage();
  const data = new Promise(async (resolve, reject) => {
    const params = {
      page: query.page,
      size: query.pageSize,
      "sort-by": "id",
      order: "desc",
    };

    const SORTABLE_FIELDS = {
      startDate: "startDate",
      type: "type",
      status: "status",
    };

    const ORDER_DIRECTIONS = {
      asc: "ASC",
      desc: "DESC",
    };

    if (query.orderBy?.field && SORTABLE_FIELDS[query.orderBy.field]) {
      params["sort-by"] = SORTABLE_FIELDS[query.orderBy.field];
      params["order"] = ORDER_DIRECTIONS[query.orderDirection];
    }

    if (query.search !== "") {
      params.search = query.search;
    }

    const response = await Request(
      "get",
      "/api/management/app-updates/idealkontrat",
      null,
      params,
    );
    if (response.status !== 200) {
      setSeverity("error");
      setSnackbarMessage(language.etc.fetchingError + response?.data?.message);
      setSnackbar(true);
    } else {
      let otherData = response?.data;
      let data = otherData.content;
      let temp = [];
      for (let i = 0; i < data.length; i++) {
        const edit = {
          id: data[i].id,
          startDate: data[i].startDate,
          type: data[i].type,
          status: data[i].status,
          username: data[i].username,
          description: data[i].description,
          logs: data[i].logs,
          isBackupNeeded: data[i].isBackupNeeded,
        };
        temp.push(edit);
      }
      setNumOfEntries(otherData.totalElements);
      resolve({
        data: temp,
        page: otherData.pageable.pageNumber,
        totalCount: otherData.totalElements,
      });
    }
  });
  return data;
}
